import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data.post)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return <div className="p-16 text-center"><h1 className="font-heading text-2xl text-primary-blue">Article introuvable</h1><Link to="/blog" className="text-primary-blue underline">Retour au blog</Link></div>;
  }
  if (!post) return <div className="p-10 text-slate-500">Chargement…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 lg:px-10 py-14">
      <Link to="/blog" className="text-primary-blue text-sm inline-flex items-center gap-1 hover:underline"><ArrowLeft size={16} /> Retour au blog</Link>
      {post.image_url && <img src={post.image_url} alt={post.title} className="mt-6 rounded-2xl w-full h-72 object-cover" />}
      <h1 className="font-heading text-4xl text-primary-blue mt-8 leading-tight" data-testid="blog-post-title">{post.title}</h1>
      <p className="mt-4 text-lg text-slate-600">{post.summary}</p>
      <div className="mt-8 prose text-slate-800 text-lg leading-relaxed whitespace-pre-line">{post.content}</div>
    </article>
  );
}
